import { render, staticRenderFns } from "./wholesale-grids-export-button.vue?vue&type=template&id=1c482c7a"
import script from "./wholesale-grids-export-button.vue?vue&type=script&lang=js"
export * from "./wholesale-grids-export-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports